import {
  CameraPlugin,
  CameraPhoto,
  CameraOptions,
  CameraResultType,
  CameraDirection,
  CameraSource,
} from '@absis/core-plugins';

export class CameraPluginWeb implements CameraPlugin {
  async getPhoto(options: CameraOptions): Promise<CameraPhoto> {
    return new Promise<CameraPhoto>(async resolve => {
      this.fileInputExperience(options, resolve);
    });
  }

  fileInputExperience(options: CameraOptions, resolve: any) {
    let input = document.querySelector(
      '#_capacitor-camera-input'
    ) as HTMLInputElement;

    const cleanup = () => {
      input.parentNode && input.parentNode.removeChild(input);
    };

    if (!input) {
      input = document.createElement('input') as HTMLInputElement;
      input.id = '_capacitor-camera-input';
      input.type = 'file';
      document.body.appendChild(input);
    }

    input.accept = 'image/*';
    (input as any).capture = true;

    if (
      options.source === CameraSource.Photos ||
      options.source === CameraSource.Prompt
    ) {
      input.removeAttribute('capture');
    } else if (options.direction === CameraDirection.Front) {
      (input as any).capture = 'user';
    } else if (options.direction === CameraDirection.Rear) {
      (input as any).capture = 'environment';
    }

    input.addEventListener('change', (_e: any) => {
      const file = input && input.files && input.files[0];
      let format = 'jpeg';

      if (file && file.type === 'image/png') {
        format = 'png';
      } else if (file && file.type === 'image/gif') {
        format = 'gif';
      }

      if (
        options.resultType === CameraResultType.DataUrl ||
        options.resultType === CameraResultType.Base64
      ) {
        const reader = new FileReader();

        reader.addEventListener('load', () => {
          if (options.resultType === CameraResultType.DataUrl) {
            resolve({
              dataUrl: reader.result,
              format,
            } as CameraPhoto);
          } else if (options.resultType === CameraResultType.Base64) {
            const b64 = (reader.result as string).split(',')[1];
            resolve({
              base64String: b64,
              format,
            } as CameraPhoto);
          }

          cleanup();
        });
        if (file) reader.readAsDataURL(file);
      } else {
        resolve({
          webPath: URL.createObjectURL(file as File),
          format: format,
        });
        cleanup();
      }
    });

    input.click();
  }
}

const CBCamera = new CameraPluginWeb();

export { CBCamera };
